/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Import global styles
import "./src/styles/tailwind.css"
import "./src/styles/global.css"

// Scroll to top on every page navigation
export const shouldUpdateScroll = () => {
  return [0, 0];
};

// Meta Pixel – PageView en cada cambio de ruta (navegación SPA incluida)
export const onRouteUpdate = () => {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView")
  }
}

// Listener global: captura cualquier click en links directos a WhatsApp
// (wa.me/593...) y dispara el evento Contact del pixel 1711305366961736.
// Se ejecuta en capture phase para registrar antes de la navegación.
export const onClientEntry = () => {
  if (typeof document === "undefined") return
  document.addEventListener(
    "click",
    (e) => {
      if (typeof window === "undefined" || typeof window.fbq !== "function") return
      const link = e.target && e.target.closest
        ? e.target.closest('a[href*="wa.me/593"]')
        : null
      if (!link) return
      window.fbq("trackSingle", "1711305366961736", "Contact")
    },
    true
  )

  // Listener global: clicks en botones que direccionan a la demo gratis
  // (ui.contalium.com/register?plan=...). Dispara el evento custom
  // "DemoButtonClick" en el pixel 1672573720639714 (inicializado sin
  // PageView en gatsby-ssr.js, por lo que SOLO cuenta clicks en demos).
  // Se ejecuta en capture phase para registrar antes de la navegación.
  document.addEventListener(
    "click",
    (e) => {
      if (typeof window === "undefined" || typeof window.fbq !== "function") return
      const link = e.target && e.target.closest
        ? e.target.closest('a[href*="ui.contalium.com/register?plan="]')
        : null
      if (!link) return
      window.fbq("trackSingleCustom", "1672573720639714", "DemoButtonClick")
    },
    true
  )
}
